/**
 * Generated from syncly-creator-spec/open-api/campaign.openapi.yaml by scripts/openapi-converter.
 * Do not edit this file directly.
 */

import { socialApiClient } from '@/shared/api-client/social-api-client';
import z from 'zod';
import {
  campaignListItemResponseSchema,
  createCampaignRequestSchema,
} from '../campaign-schema';

export const createCampaignPathSchema = z.object({ workspaceId: z.string() });

export const createCampaignRequestBodySchema = createCampaignRequestSchema;

export const createCampaignOperationResponseSchema =
  campaignListItemResponseSchema;

export type CreateCampaignInput = {
  path: z.input<typeof createCampaignPathSchema>;
  body?: z.input<typeof createCampaignRequestBodySchema>;
  signal?: AbortSignal;
};

export async function createCampaign({
  path,
  body,
  signal,
}: CreateCampaignInput): Promise<
  z.infer<typeof createCampaignOperationResponseSchema>
> {
  const parsedPath = createCampaignPathSchema.parse(path);
  const parsedBody =
    body === undefined
      ? undefined
      : createCampaignRequestBodySchema.parse(body);

  const response = await socialApiClient.post(
    `workspaces/${parsedPath.workspaceId}/campaigns`,
    {
      signal,
      ...(parsedBody === undefined ? {} : { json: parsedBody }),
    },
  );
  return createCampaignOperationResponseSchema.parse(await response.json());
}
